/**
 * 全局公共api
 */

import request from './request';
// import downloadFile from '@/utils/downloadFile';

export function demo(params) {
    return request('/demo', {
        method: 'GET',
        params,
    });
}

/**
 * 查询所有菜单树
 */
export function getMenuTree(params) {
    return request('/menu/tree', {
        method: 'GET',
        params,
    });
}

/**
 * 导出数据
 */
// export function exportData(url) {
//     return request(url, {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/vnd.ms-excel',
//         },
//         responseType: 'blob', // arraybuffer
//     })
//     .then(res => {
//         const blob = new Blob([
//             res.data,
//         ], {
//             type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
//         });
//         const objectUrl = URL.createObjectURL(blob);
//         const link = document.createElement('a');
//         link.href = objectUrl;
//         link.setAttribute('download');
//         document.body.appendChild(link);
//         link.click();
//     });
// }

/**
 * 获取阿里云OSS凭证
 */
export function getOssToken(params) {
    return request('/oss/sts', {
        method: 'GET',
        params,
    });
}

/**
 * 碰撞 桌面消息通知（轮询接口）
 */
export function getNotification(params) {
    return request('/collision/remind', {
        method: 'GET',
        params,
    });
}

/**
 * 碰撞 关闭桌面消息通知
 */
export function closeNotification() {
    return request('/collision/remind', {
        method: 'POST',
    });
}

/**
 * 基础数据-获取所有车辆种类
 */
export function getVehicleType() {
    return request('/vehicle/level', {
        method: 'GET',
    });
}

/**
 * 基础数据-获取所有的车辆品牌
 */
export function getVehicleBrand() {
    return request('/vehicle/brand', {
        method: 'GET',
    });
}

/**
 * 基础数据-获取某品牌下的所有车系
 */
export function getVehicleSeries(id) {
    return request(`/vehicle/brand-${id}/series`, {
        method: 'GET',
    });
}

/**
 * 基础数据-获取某车系下的所有车型
 */
export function getVehicleModel(id) {
    return request(`/vehicle/series-${id}/model`, {
        method: 'GET',
    });
}

/**
 * 客户管理-获取大数据标签分类
 */
export function getTagsTypeList() {
    return request('/tags-type/list-all', {
        method: 'GET',
    });
}

/**
 * 客户管理-获取大数据标签
 */
export function getTags(params) {
    return request('/tags/list', {
        method: 'GET',
        params,
    });
}

/**
 * 创建活动-根据组织查询搜索标签树
 */
export function getTagsTree() {
    return request('/tags-type/tags-tree', {
        method: 'POST',
    });
}

// 导出
export function exportData(url, params, method) {
    return request(url, {
        method,
        params,
        responseType: 'blob',
    });
}
/**
 *  碰撞救援新手引导
 */
export function setCollisionGuide() {
    return request('/user/info/guide-tags-clue', {
        method: 'POST',
    });
}
/**
 * 经营数据分析-碰撞到店转化漏斗查询
 */
export function getClueFunnel(params) {
    return request('/stat/clue/funnel', {
        method: 'POST',
        params,
    });
}
